let BASE_URL = '';
let BACK_URL = '';
let UPLOAD_URL = '';
// BASE_URL请求地址
// BACK_URL跳转后台地址
switch (process.env.VUE_APP_CURENV) {
    case "development":  // 本地
        // BASE_URL = "http://10.14.0.43:8080";
        BASE_URL = "http://172.16.100.89/api";
        UPLOAD_URL = "http://172.16.100.89:80";
        BACK_URL = "http://localhost:8080";
        break;
    case "test":
        BASE_URL = "http://172.16.100.89/api";
        UPLOAD_URL = "http://172.16.100.89:80";
        BACK_URL = "http://172.16.100.89:8888";
        break;
    case "production":
        BASE_URL = "http://cokeinfo.risuncloud.com/api";
        UPLOAD_URL = "http://cokeinfo.risuncloud.com:80";
        BACK_URL = "http://cokeinfo.risuncloud.com:8888";
        break;
}

//接口地址
module.exports = {
    BASE_URL,
    BACK_URL,
    UPLOAD_URL
}
